import React from 'react'
import { IReportingProps } from './ICommonProps'

export abstract class ISearchForm<T, Y> extends React.Component<
  T & IReportingProps,
  Y
> {}
